import { render, staticRenderFns } from "./distributionDetailHome.vue?vue&type=template&id=639a62b0&scoped=true"
import script from "./distributionDetailHome.vue?vue&type=script&lang=js"
export * from "./distributionDetailHome.vue?vue&type=script&lang=js"
import style0 from "./distributionDetailHome.vue?vue&type=style&index=0&id=639a62b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a62b0",
  null
  
)

export default component.exports